import React, { useEffect } from "react";

import "./styles.css";

const MARK_SRC = "/assets/logo/sayagie-mark.png";

const BootOverlay = ({ label = "Loading Sayagie" }) => {
  useEffect(() => {
    return () => {
      document.documentElement.removeAttribute("data-boot");
    };
  }, []);

  return (
    <div className="sy-boot" role="status" aria-live="polite" aria-label={label}>
      <span className="sy-boot-mark-wrap">
        <span className="sy-boot-halo" aria-hidden="true" />
        <span className="sy-boot-ring" aria-hidden="true" />
        <img className="sy-boot-mark" src={MARK_SRC} alt="" aria-hidden="true" />
      </span>

      <span className="sy-boot-wordmark" aria-hidden="true">
        SAYAGIE
      </span>
    </div>
  );
};

export default BootOverlay;
